import Cookie from 'js-cookie';
import axios from 'axios';

export default class AdSegmentationService {
    constructor(private apiUrl: string, private apiKey: string, private cookieDomain: string = '.hvg.hu') { }
    public async send(segmentId: string) {

        var advMeta = document.querySelector('meta[name="advmeta-cc"]');

        if (advMeta !== null) {
            var adverticumClientInstanceCookieName = advMeta.getAttribute("content");

            var putRequestUrl = `${this.apiUrl}client-segments?clientInstance=${adverticumClientInstanceCookieName}`;
            if (this.apiKey !== null && this.apiKey !== '') {
                putRequestUrl = (putRequestUrl + '&apikey=' + this.apiKey);
            }

            if (adverticumClientInstanceCookieName !== null) {
                var result = await axios.put(putRequestUrl, [segmentId]);
            }
        }     
    };
}